import { render, staticRenderFns } from "./StateChanger.vue?vue&type=template&id=5b1f2870&scoped=true&"
import script from "./StateChanger.vue?vue&type=script&lang=js&"
export * from "./StateChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f2870",
  null
  
)

export default component.exports